import "./GarageDoorRepairNorthernBeaches.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageVision from "./sections/GarageVision";
import GarageServices from "./sections/GarageServices";
import ServicePartners from "./sections/ServicePartners";
import GarageProcess from "./sections/GarageProcess";
import WhyChooseUs from "./sections/WhyChooseUs";
import Serviceareas from "./sections/Serviceareas";
import Testimonials from "./sections/Testimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import SiteFooter from "./sections/SiteFooter";
export default function GarageDoorRepairNorthernBeachesPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageVision />
      <GarageServices />
      <ServicePartners />
      <GarageProcess />
      <WhyChooseUs />
      <Serviceareas />
      <Testimonials />
      <GarageFaq />
      <GarageCta />
      <SiteFooter />
    </div>;
}